export default __webpack_public_path__ + "static/media/upc-logo-branco-02.14c18f32.png";